import { Button } from 'design-system'
import { Mail } from 'lucide-react'
import React, { FC } from 'react'

import { displayName } from 'shared/lib/user'
import { useNetworkName } from 'src/hooks/use-network-name'

import { useFlags } from 'src/lib/feature-flags/feature-flags'

import { useStartThread } from './use-start-thread'
import { useOpenDirectThread } from 'src/components/user/v2/use-open-direct-thread'
import { UserMenuType } from './types'

interface ButtonProps {
  profile: UserMenuType
  className: string
  messagesEnabled: boolean
  isOwnProfile: boolean
}

const MessageButton: FC<ButtonProps> = ({
  profile,
  className,
  messagesEnabled,
  isOwnProfile
}) => {
  const profileDisplayName = displayName(profile)
  const networkName = useNetworkName()

  const startThread = useStartThread()
  const { openDirectThread } = useOpenDirectThread(profile.id, networkName)
  const { gqlUserMessage } = useFlags()

  if (isOwnProfile || !messagesEnabled) {
    return null
  }

  const onClick = () =>
    gqlUserMessage ? openDirectThread() : startThread(profile)

  return (
    <Button
      buttonType="primary"
      buttonSize="sm"
      className={className}
      onClick={onClick}
      leftIconSlot={<Mail />}
      aria-label={`Send a direct message to ${profileDisplayName}`}>
      Message
    </Button>
  )
}

export default MessageButton
